module.exports = __webpack_public_path__ + "img/house-damage.fa592b94.svg";